var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.duration > 0)?_c('g-typography',_vm._b({attrs:{"value":_vm.countdownText}},'g-typography',_vm.$attrs,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }